import React from 'react';
import cn from 'classnames';

import type { TFormWrapperPropsDesktop } from './models';

export const FormWrapper = ({
    children,
    className,
    dataTestId,
    shadow = true,
    styles,
}: TFormWrapperPropsDesktop) => {
    return (
        <div
            className={cn(
                styles.formWrapperDesktop,
                { [styles.formWrapperShadow]: shadow },
                className
            )}
            data-test-id={dataTestId}
        >
            {children}
        </div>
    );
};
